import React, { useEffect, useRef, useState } from "react";
import { Typography } from "@material-tailwind/react";
import { Link } from "react-scroll";
import {
  SECTION_NAV_ITEMS,
  SECTION_SCROLL_OFFSET,
} from "../navigation/sectionNavConfig";

const MobileSectionNav = () => {
  const [activeSection, setActiveSection] = useState(SECTION_NAV_ITEMS[0].to);
  const [isScrollable, setIsScrollable] = useState(false);
  const linksRef = useRef(null);

  useEffect(() => {
    const updateScrollableState = () => {
      const links = linksRef.current;
      if (!links) {
        return;
      }

      setIsScrollable(links.scrollWidth > links.clientWidth + 4);
    };

    updateScrollableState();
    window.addEventListener("resize", updateScrollableState);

    return () => {
      window.removeEventListener("resize", updateScrollableState);
    };
  }, []);

  return (
    <nav className="mobile-section-nav" aria-label="Section navigation">
      <div className="mobile-section-nav-surface">
        <div className="mobile-section-nav-inner">
          <Typography className="mobile-section-nav-label">
            Jump to section
          </Typography>
          <div className="mobile-section-nav-track">
            <div
              ref={linksRef}
              className={`mobile-section-nav-links ${
                !isScrollable ? "mobile-section-nav-links-centered" : ""
              }`}
            >
              {SECTION_NAV_ITEMS.map((section) => (
                <Link
                  key={section.to}
                  to={section.to}
                  spy={true}
                  smooth="easeInQuad"
                  duration={200}
                  offset={SECTION_SCROLL_OFFSET}
                  // onClick={() => setActiveSection(section.to)}
                  onSetActive={() => setActiveSection(section.to)}
                  className={`mobile-section-nav-link ${
                    activeSection === section.to ? "active" : ""
                  }`}
                >
                  {section.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default MobileSectionNav;
